import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';

import config from 'config';

import rootReducer from './reducers/root';

const persistConfig = {
  key: config.store,
  storage,
};

const loggerConfig = {
  collapsed: true,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const composeEnchancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default (initState) => {
  const store = createStore(
    persistedReducer,
    initState,
    composeEnchancers(applyMiddleware(
      thunk,
      createLogger(loggerConfig)
    ))
  );
  const persistor = persistStore(store);
  return {store, persistor};
}



// WEBPACK FOOTER //
// ./src/app/store/configureStore.js